import http from '@/utils/http';
import { queryFormatter } from '@/utils';


// 添加矛盾预约
export const addConflict = data => http.post('/api/conflict/', data, 'application/json;charset=utf-8');

// 查询养犬地址
export const getDog = param => http.get(`/api/dog/${queryFormatter(param)}`);

// 获取核酸检测地址
export const getCovid = param => http.get(`/api/covid/location/${queryFormatter(param)}`);

// 功能图标查看
export const getIcons = param => http.get(`/api/icon/${queryFormatter(param)}`);
